module.exports = {
  siteTitle: 'MQA Japan',
  siteTitleAlt: 'MQA Japan', // This allows an alternative site title for SEO schema.
  publisher: 'MQA', // Organization name used for SEO schema
  keywords: 'MQA, 音楽, ハイレゾ, エムキューエー, ハイクオリティ, 高音質,音源',
  siteDescription: 'TAKE ME THERE ー 音楽が生まれる場所へ。オーディオテクノロジーMQAで、これまでにない音楽体験を。',
  siteUrl: 'https://mqa.jp', // Site domain. Do not include a trailing slash! If you wish to use a path prefix you can read more about that here: https://www.gatsbyjs.org/docs/path-prefix/
  author: 'AKQA', // Author for RSS author segment and SEO schema
  authorUrl: 'https://akqa.com/about/', // URL used for author and publisher schema, can be a social profile or other personal site
  userTwitter: '@MQAMusic', // Change for Twitter Cards
  shortTitle: 'MQA Japan', // Used for App manifest e.g. Mobile Home Screen
  shareImage: 'https://mqa.jp/logos/MQA_ogp.jpg', // Open Graph Default Share Image. 1200x1200 is recommended
  shareImageWidth: 1200, // Change to the width of your default share image
  shareImageHeight: 630, // Change to the height of your default share image
  siteLogo: '/logos/favicon.png', // Logo used for SEO, RSS, and App manifest
  backgroundColor: '#f3f3f3', // Used for Offline Manifest
  themeColor: '#f3f3f3', // Used for Offline Manifest
  copyright: 'Copyright © 2019 MQA', // Copyright string for the RSS feed
}
